/**
 * Bundle Selector A/B Test — Test B interactions & add-to-cart
 */
(function () {
  'use strict';

  function getFormId(form) {
    return form && form.getAttribute ? form.getAttribute('id') : '';
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{amount}}') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, value);
    }
    if (format && format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    return '$' + value;
  }

  function getProductForm(formId) {
    if (!formId) return null;
    var byId = document.getElementById(formId);
    if (byId && byId.tagName === 'FORM') return byId;
    if (document.forms[formId]) return document.forms[formId];
    return document.querySelector('form[is="product-form"][id="' + String(formId).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
  }

  function isBackpackPdpPage() {
    var path = String((typeof location !== 'undefined' && location.pathname) || '').toLowerCase();
    if (
      path.indexOf('/products/backpack') !== -1 ||
      path.indexOf('/products/aerless-backpack') !== -1
    ) {
      return true;
    }
    return !!document.querySelector('.product-bundle-upsell[data-pdp-type="backpack"]');
  }

  /** Backpack only: custom bundle shows when horizontal AB is true; false = original static PDP. */
  function isBackpackHorizontalBundleOn() {
    if (!document.body) return false;
    try {
      var q = new URLSearchParams(window.location.search).get('bundle_horizontal_test');
      if (q === 'b' || q === 'true' || q === '1') return true;
      if (q === 'a' || q === 'false' || q === '0') return false;
    } catch (e) { /* ignore */ }
    var v = document.body.getAttribute('data-bundle-horizontal-ab');
    if (v === 'true') return true;
    if (v === 'false') return false;
    return document.documentElement.classList.contains('bundle-horizontal-ab--active');
  }

  function getAbEnabled() {
    var body = document.body;
    var bodyVal = body.getAttribute('data-bundle-selector-ab');
    var selectorOn = false;
    if (bodyVal === 'true') selectorOn = true;
    else if (bodyVal === 'false') selectorOn = false;
    else selectorOn = !!document.querySelector('[data-bundle-selector-ab-wrapper="true"]');

    if (!selectorOn) return false;

    // Backpack PDP: gate entire custom bundle on data-bundle-horizontal-ab
    if (isBackpackPdpPage() && !isBackpackHorizontalBundleOn()) return false;

    return true;
  }

  function isTravelsetPacksAb() {
    if (!document.body) return false;
    try {
      var q = new URLSearchParams(window.location.search).get('travelset_packs_test');
      if (q === 'b' || q === 'true' || q === '1') return true;
    } catch (e) { /* ignore */ }
    var v = document.body.getAttribute('data-travelset-packs-ab') ||
      document.documentElement.getAttribute('data-travelset-packs-ab');
    if (
      String(v || '').trim().toLowerCase() === 'true' ||
      String(v || '').trim() === '1' ||
      String(v || '').trim().toLowerCase() === 'on'
    ) {
      return true;
    }
    // Fallback: CSS class already active (IntelliGems / late attribute flips)
    // BOGO / travelset-packs always wins over pack-more-bundle-ab title swap.
    return document.documentElement.classList.contains('travelset-packs-ab--active') ||
      document.body.classList.contains('travelset-packs-ab--active');
  }

  // Apply packs class ASAP so CSS shows pack swatches even before full init
  function applyTravelsetPacksClass() {
    var on = isTravelsetPacksAb();
    document.documentElement.classList.toggle('travelset-packs-ab--active', on);
    if (document.body) document.body.classList.toggle('travelset-packs-ab--active', on);
  }
  if (document.body) applyTravelsetPacksClass();
  else document.addEventListener('DOMContentLoaded', applyTravelsetPacksClass);

  function isMobile() {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  function getCheckedAddonVariantIds(productId) {
    var ids = [];
    var seen = {};

    function pushVid(el) {
      var vid = el.getAttribute('data-addon-variant-id');
      if (!vid) return;
      var n = parseInt(vid, 10);
      if (!seen[n]) {
        seen[n] = true;
        ids.push(n);
      }
    }

    document.querySelectorAll('input.product-addon__toggle[data-addon-variant-id]:checked').forEach(pushVid);

    if (productId) {
      document.querySelectorAll('.addon-checkbox-' + productId + ':checked').forEach(pushVid);
    }

    document.querySelectorAll('.addon-toggle-input:checked[data-addon-variant-id]').forEach(pushVid);

    return ids;
  }

  function resetCheckedAddonToggles(productId) {
    document.querySelectorAll('input.product-addon__toggle[data-addon-variant-id]:checked').forEach(function (el) {
      el.checked = false;
      var card = el.closest('.addon-card') || el.closest('.product-addon');
      if (card) card.classList.remove('is-selected');
    });

    if (productId) {
      document.querySelectorAll('.addon-checkbox-' + productId + ':checked').forEach(function (el) {
        el.checked = false;
        var card = el.closest('.addon-card');
        if (card) card.classList.remove('is-selected');
      });
    }

    document.querySelectorAll('.addon-toggle-input:checked').forEach(function (el) {
      el.checked = false;
      var card = el.closest('.addon-card');
      if (card) card.classList.remove('is-selected');
    });
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer, cart-notification-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') {
      cartDrawer.show();
    } else {
      var toggle = document.querySelector('[data-drawer-open="cart"], [aria-controls="cart-drawer"]');
      if (toggle) toggle.click();
    }
  }

  function applyDiscountCode(code) {
    if (!code) return Promise.resolve(null);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var normalized = String(code).trim();
    if (!normalized) return Promise.resolve(null);

    // Prefer Ajax Cart API — reliably attaches the code to the current cart.
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: normalized })
    })
      .then(function (response) {
        if (response.ok) return response.json();
        // Fallback: classic storefront discount URL (sets discount_code cookie)
        return fetch(root + 'discount/' + encodeURIComponent(normalized), {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow'
        }).then(function () {
          try {
            document.cookie =
              'discount_code=' + encodeURIComponent(normalized) + '; path=/; SameSite=Lax';
          } catch (e) { /* ignore */ }
          return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
            return res.ok ? res.json() : null;
          });
        });
      })
      .catch(function (err) {
        console.warn('Could not apply discount code:', normalized, err);
        try {
          document.cookie =
            'discount_code=' + encodeURIComponent(normalized) + '; path=/; SameSite=Lax';
        } catch (e) { /* ignore */ }
        return fetch(root + 'discount/' + encodeURIComponent(normalized), {
          method: 'GET',
          credentials: 'same-origin'
        })
          .then(function () {
            return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
              return res.ok ? res.json() : null;
            });
          })
          .catch(function () {
            return null;
          });
      });
  }

  function fetchCartWithSections(sectionId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!sectionId) {
      return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
        return res.ok ? res.json() : null;
      });
    }
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        sections: [sectionId],
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).catch(function () {
      return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) {
        return r.ok ? r.json() : null;
      });
    });
  }

  // TRAVELSET (backpack) is disabled — still tracked so leftovers get cleared.
  // TRAVELSET20 = weekender Travel Set only (weekender + vacuum).
  var BACKPACK_BUNDLE_CODE = 'TRAVELSET';
  var WEEKENDER_BUNDLE_CODE = 'TRAVELSET20';

  function getBundleDiscountCodesFromPage() {
    var codes = [];
    var seen = {};

    document.querySelectorAll('.product-bundle-upsell [data-bundle-config]').forEach(function (el) {
      try {
        var config = JSON.parse(el.textContent);
        if (!config.overpackerDiscountCode) return;
        var code = String(config.overpackerDiscountCode).trim().toUpperCase();
        if (code && !seen[code]) {
          seen[code] = true;
          codes.push(code);
        }
      } catch (err) {
        /* ignore invalid config */
      }
    });

    return codes;
  }

  function getBundleDiscountCodes() {
    var codes = getBundleDiscountCodesFromPage();
    var seen = {};
    var merged = [];

    // Always track both so a leftover cookie from the other PDP can be cleared.
    [WEEKENDER_BUNDLE_CODE, BACKPACK_BUNDLE_CODE].concat(codes).forEach(function (code) {
      var normalized = String(code || '').trim().toUpperCase();
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      merged.push(normalized);
    });

    return merged.length ? merged : [WEEKENDER_BUNDLE_CODE];
  }

  function getBundleWeekenderProductIds() {
    var ids = [];
    var seen = {};
    document.querySelectorAll('.product-bundle-upsell [data-bundle-config]').forEach(function (el) {
      try {
        var config = JSON.parse(el.textContent);
        var weekenderId = parseInt(config.weekenderProductId, 10);
        if (!weekenderId || seen[weekenderId]) return;
        seen[weekenderId] = true;
        ids.push(weekenderId);
      } catch (err) {
        /* ignore */
      }
    });
    return ids;
  }

  function getBundleProductPairs() {
    var pairs = [];
    var seen = {};

    document.querySelectorAll('.product-bundle-upsell [data-bundle-config]').forEach(function (el) {
      try {
        var config = JSON.parse(el.textContent);
        var weekenderId = parseInt(config.weekenderProductId, 10);
        var vacuumId = parseInt(config.vacuumProductId, 10);
        if (!weekenderId || !vacuumId) return;
        var key = weekenderId + ':' + vacuumId;
        if (seen[key]) return;
        seen[key] = true;
        pairs.push({
          weekenderProductId: weekenderId,
          vacuumProductId: vacuumId,
          discountCode: String(config.overpackerDiscountCode || '').trim().toUpperCase(),
          isBackpackPdp: !!config.isBackpackPdp,
          pdpHandle: String(config.pdpHandle || '').toLowerCase()
        });
      } catch (err) {
        /* ignore invalid config */
      }
    });

    return pairs;
  }

  function itemLooksLikeBackpack(item) {
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();
    var url = String(item.url || '').toLowerCase();
    return (
      handle.indexOf('backpack') !== -1 ||
      title.indexOf('backpack') !== -1 ||
      url.indexOf('/products/backpack') !== -1 ||
      url.indexOf('aerless-backpack') !== -1
    );
  }

  function itemLooksLikeWeekender(item) {
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();
    var url = String(item.url || '').toLowerCase();
    return (
      (handle.indexOf('weekender') !== -1 ||
        title.indexOf('weekender') !== -1 ||
        url.indexOf('/products/weekender') !== -1) &&
      !itemLooksLikeBackpack(item)
    );
  }

  function itemLooksLikeVacuum(item) {
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();
    var url = String(item.url || '').toLowerCase();
    return (
      handle.indexOf('vacuum') !== -1 ||
      title.indexOf('vacuum') !== -1 ||
      url.indexOf('/products/vacuum') !== -1
    );
  }

  function cartQualifiesForBogoDiscount(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    var weekenderIds = getBundleWeekenderProductIds();
    var qty = 0;

    cart.items.forEach(function (item) {
      var productId = parseInt(item.product_id, 10);
      var isWeekender = weekenderIds.indexOf(productId) !== -1 || itemLooksLikeWeekender(item);
      // BOGO is weekender-only — never count backpack
      if (isWeekender && !itemLooksLikeBackpack(item)) {
        qty += parseInt(item.quantity, 10) || 0;
      }
    });

    return qty >= 2;
  }

  /** Backpack TRAVELSET is disabled — never treat as eligible. */
  function cartQualifiesForBackpackTravelSet() {
    return false;
  }

  /** TRAVELSET20 = weekender + vacuum only. Never backpack. */
  function cartQualifiesForWeekenderTravelSet(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    var hasWeekender = false;
    var hasVacuum = false;
    cart.items.forEach(function (item) {
      if (itemLooksLikeWeekender(item) && !itemLooksLikeBackpack(item)) hasWeekender = true;
      if (itemLooksLikeVacuum(item)) hasVacuum = true;
    });
    return hasWeekender && hasVacuum;
  }

  function cartQualifiesForTravelSetDiscount(cart) {
    return cartQualifiesForWeekenderTravelSet(cart);
  }

  function cartQualifiesForDiscountCode(cart, code) {
    var normalized = String(code || '').trim().toUpperCase();
    if (!normalized) return false;
    // Backpack TRAVELSET turned off — always clear leftovers, never keep.
    if (normalized === BACKPACK_BUNDLE_CODE) return false;
    if (normalized === WEEKENDER_BUNDLE_CODE) return cartQualifiesForWeekenderTravelSet(cart);

    var pairs = getBundleProductPairs();
    for (var i = 0; i < pairs.length; i++) {
      if (pairs[i].discountCode !== normalized) continue;
      if (pairs[i].isBackpackPdp) return false;
      return cartQualifiesForWeekenderTravelSet(cart);
    }

    return cartQualifiesForTravelSetDiscount(cart);
  }

  function cartQualifiesForBundleDiscount(cart) {
    return cartQualifiesForTravelSetDiscount(cart) || cartQualifiesForBogoDiscount(cart);
  }

  function getActiveBundleDiscountCode(cart) {
    var bundleCodes = getBundleDiscountCodes();
    if (!bundleCodes.length) return null;

    var cookieCode = getDiscountCookieValue().toUpperCase();
    if (cookieCode && bundleCodes.indexOf(cookieCode) !== -1) return cookieCode;

    if (cart && cart.cart_level_discount_applications) {
      for (var i = 0; i < cart.cart_level_discount_applications.length; i++) {
        var title = (
          cart.cart_level_discount_applications[i].title ||
          cart.cart_level_discount_applications[i].code ||
          ''
        ).toUpperCase();
        for (var j = 0; j < bundleCodes.length; j++) {
          if (title.indexOf(bundleCodes[j]) !== -1) return bundleCodes[j];
        }
      }
    }

    return null;
  }

  function cartHasBundleDiscount(cart) {
    return !!getActiveBundleDiscountCode(cart);
  }

  function getDiscountCookieValue() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return match ? decodeURIComponent(match[1]).trim() : '';
  }

  function expireDiscountCookies() {
    var hostname = window.location.hostname;
    var hostVariants = [hostname];
    if (hostname.indexOf('www.') === 0) {
      hostVariants.push(hostname.slice(4));
    }
    var domains = [''];
    hostVariants.forEach(function (host) {
      domains.push(host);
      domains.push('.' + host);
    });

    ['discount_code', 'discount'].forEach(function (name) {
      domains.forEach(function (domain) {
        var base = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
        document.cookie = base + (domain ? '; domain=' + domain : '');
      });
    });
  }

  function clearDiscountFromCartSession() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function refreshCartAfterDiscountChange() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cartContent) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'discount:clear', cart: cartContent }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cartContent }
        }));
        return cartContent;
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  }

  function clearBundleDiscountIfActive() {
    var bundleCodes = getBundleDiscountCodes();
    if (!bundleCodes.length) return Promise.resolve();

    var cookieCode = getDiscountCookieValue().toUpperCase();
    var cookieMatches = cookieCode && bundleCodes.indexOf(cookieCode) !== -1;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var activeCode = getActiveBundleDiscountCode(cart);
        // No TRAVELSET / TRAVELSET20 in cookie or cart — nothing to do.
        if (!activeCode && !cookieMatches) {
          return null;
        }

        var codeToCheck = activeCode || cookieCode;
        // Keep only eligible weekender TRAVELSET20 (weekender+vacuum).
        // Strip TRAVELSET leftovers and any other ineligible codes.
        if (codeToCheck && cartQualifiesForDiscountCode(cart, codeToCheck)) {
          return null;
        }

        expireDiscountCookies();
        return clearDiscountFromCartSession();
      })
      .then(function (result) {
        if (result === null) return;
        return refreshCartAfterDiscountChange();
      })
      .catch(function () {
        if (cookieMatches) {
          expireDiscountCookies();
          return clearDiscountFromCartSession().then(function () {
            return refreshCartAfterDiscountChange();
          });
        }
      });
  }

  function enforceBundleDiscountEligibility(cart, skipRefresh) {
    var activeCode = getActiveBundleDiscountCode(cart);
    if (!activeCode) return Promise.resolve(cart);

    // Keep TRAVELSET20 only for weekender+vacuum. TRAVELSET (backpack) is always cleared.
    if (cartQualifiesForDiscountCode(cart, activeCode)) {
      return Promise.resolve(cart);
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    expireDiscountCookies();
    return clearDiscountFromCartSession()
      .then(function () {
        return fetch(root + 'cart.js').then(function (res) { return res.json(); });
      })
      .then(function (freshCart) {
        if (skipRefresh) return freshCart;
        return refreshCartAfterDiscountChange().then(function () {
          return freshCart;
        });
      })
      .catch(function () {
        return cart;
      });
  }

  function addItemsToCart(items, submitBtn, productId, discountCode) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawerEl = document.querySelector('cart-drawer');
    var sectionId = drawerEl && drawerEl.closest('.shopify-section')
      ? drawerEl.closest('.shopify-section').id.replace('shopify-section-', '')
      : '';

    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.disabled = true;
    }

    var beforeAdd = discountCode ? Promise.resolve() : clearBundleDiscountIfActive();

    return beforeAdd.then(function () {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections: sectionId || 'variant-added',
          sections_url: root + 'variants/' + items[0].id
        })
      });
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return response.json();
      })
      .then(function (cartData) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        function finishWithCart(cartContent) {
          if (!cartContent) {
            return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
              return res.json();
            });
          }
          return Promise.resolve(cartContent);
        }

        var afterDiscount = discountCode
          ? applyDiscountCode(discountCode)
          : Promise.resolve(null);

        return afterDiscount
          .then(function (discountCart) {
            // Re-fetch AFTER discount so drawer sections/totals match ($199 not $218).
            if (discountCode) {
              return fetchCartWithSections(sectionId).then(function (fresh) {
                return fresh || discountCart;
              });
            }
            if (cartData && cartData.sections) {
              return finishWithCart(null).then(function (c) {
                c.sections = cartData.sections;
                return c;
              });
            }
            return fetchCartWithSections(sectionId);
          })
          .then(finishWithCart)
          .then(function (cartContent) {
            return enforceBundleDiscountEligibility(cartContent, true).then(function (validatedCart) {
              return validatedCart || cartContent;
            });
          })
          .then(function (cartContent) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartContent }
            }));
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cartContent }
            }));
            resetCheckedAddonToggles(productId);
            openCartDrawer();
          });
      })
      .catch(function (err) {
        console.error('Bundle add to cart error:', err);
        alert(err.message || 'Could not add items to cart.');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('aria-busy');
          submitBtn.disabled = false;
        }
      });
  }

  function applyAbVisibility() {
    var enabled = getAbEnabled();
    document.documentElement.classList.toggle('bundle-selector-ab--active', enabled);

    document.querySelectorAll('.kaching-bundles__block, kaching-bundle, kaching-bundles, kaching-bundles-block').forEach(function (el) {
      el.classList.toggle('bundle-selector-ab__test-a', enabled);
      if (enabled && el.closest('.product-info__block-item[data-block-type="buy-buttons"]')) {
        el.setAttribute('hidden', 'hidden');
        el.style.display = 'none';
      } else if (!enabled) {
        el.removeAttribute('hidden');
        el.style.display = '';
      }
    });

    document.querySelectorAll('.product-info__block-item[data-block-type="buy-buttons"]').forEach(function (blockItem) {
      blockItem.classList.remove('bundle-selector-ab__test-a');
      blockItem.style.display = '';
    });
  }

  window.BundleSelectorAb = window.BundleSelectorAb || {
    instances: {},
    register: function (formId, api) {
      this.instances[formId] = api;
    },
    getInstance: function (formId) {
      return this.instances[formId];
    },
    getCartItems: function (formId) {
      var instance = this.getInstance(formId);
      return instance ? instance.getBundleCartItems() : [];
    },
    mergeWithAddons: function (formId, bundleItems) {
      var instance = this.getInstance(formId);
      return instance ? instance.mergeWithCheckedAddons(bundleItems) : bundleItems;
    },
    refreshPending: function (formId) {
      var items = this.getCartItems(formId);
      if (items.length) {
        window.BUNDLE_SELECTOR_PENDING = { items: items, formId: formId };
      }
      return items;
    },
    handleFormSubmit: function (form, event) {
      if (!getAbEnabled()) return false;
      var instance = this.getInstance(getFormId(form));
      if (!instance) return false;
      var submitBtn = (event && event.submitter) ||
        form.querySelector('button[type="submit"], [type="submit"]');
      return instance.processAtc(submitBtn, form);
    },
    isActive: function () {
      return getAbEnabled() && !!document.querySelector('.product-bundle-upsell [data-bundle-config]');
    },
    getDiscountCode: function (formId) {
      var instance = this.getInstance(formId);
      return instance && instance.getDiscountCode ? instance.getDiscountCode() : null;
    },
    applyDiscountCode: applyDiscountCode,
    applyDiscountForForm: function (formId) {
      return applyDiscountCode(this.getDiscountCode(formId));
    },
    clearBundleDiscount: function () {
      return clearBundleDiscountIfActive();
    },
    cartQualifiesForBundleDiscount: cartQualifiesForBundleDiscount
  };

  // Live Kaching "Travel Combo" on the backpack. Refreshed from the app deal blocks when the page config is available.
  var backpackKachingDeal = {
    deal: 'ohLG',
    versionId: '79cf0543-1432-429b-9a88-3b12ab0e7477',
    barId: 'eIjx',
    bundleProductId: 'Iqce',
    pageProductId: 16323537469785,
    allowedVariantIds: null
  };

  function gidToId(gid) {
    if (gid == null || gid === '') return null;
    if (typeof gid === 'number') return gid;
    var parts = String(gid).split('/');
    var id = parseInt(parts[parts.length - 1], 10);
    return isNaN(id) ? null : id;
  }

  function kachingDealHash(payload) {
    var str = JSON.stringify(payload);
    var hash = 2166136261;
    var i;
    for (i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash = Math.imul(hash, 16777619) >>> 0;
    }
    var alphabet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var out = '';
    var n = hash >>> 0;
    for (i = 0; i < 4; i++) {
      out = alphabet.charAt(n % 62) + out;
      n = Math.floor(n / 62);
    }
    return out;
  }

  function buildBackpackBundleCartItems(backpackVariantId, vacuumVariantId) {
    var backpackId = parseInt(backpackVariantId, 10);
    var vacuumId = parseInt(vacuumVariantId, 10);
    var items = [];
    var deal = backpackKachingDeal;
    if (!backpackId) return items;

    if (!vacuumId || !deal || !deal.deal || !deal.barId || !deal.bundleProductId) {
      items.push({ id: backpackId, quantity: 1 });
      if (vacuumId) items.push({ id: vacuumId, quantity: 1 });
      return items;
    }

    var groupId = kachingDealHash([
      [{ variantId: backpackId, quantity: 1 }],
      [{ id: deal.bundleProductId, variantId: vacuumId, quantity: 1 }],
      [],
      [],
      [],
      [],
      [],
      null,
      null,
      deal.barId
    ]);

    var mainProps = {
      deal: deal.deal,
      pp: deal.pageProductId,
      main: true
    };
    if (deal.versionId) mainProps.v = deal.versionId;
    mainProps.id = groupId;
    mainProps.bar = deal.barId;

    var vacuumProps = {
      id: groupId,
      deal: deal.deal,
      bar: deal.barId
    };
    if (deal.versionId) vacuumProps.v = deal.versionId;
    vacuumProps.bundleProduct = deal.bundleProductId;

    items.push({
      id: backpackId,
      quantity: 1,
      properties: { __kaching_bundles: JSON.stringify(mainProps) }
    });
    items.push({
      id: vacuumId,
      quantity: 1,
      properties: { __kaching_bundles: JSON.stringify(vacuumProps) }
    });
    return items;
  }

  function loadBackpackKachingDeal() {
    var cfgEl = document.getElementById('kaching-bundles-config');
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    if (!cfg || !cfg.storefrontAccessToken || !cfg.shopifyDomain || !cfg.productId) return;

    fetch('https://' + cfg.shopifyDomain + '/api/2026-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': cfg.storefrontAccessToken
      },
      body: JSON.stringify({
        query: 'query FetchDealBlocks($metafieldNamespace: String!) { shop { metafield(namespace: $metafieldNamespace, key: "deal_blocks") { value } } }',
        variables: { metafieldNamespace: '$app:kaching_bundles' }
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (payload) {
        var raw = payload && payload.data && payload.data.shop && payload.data.shop.metafield && payload.data.shop.metafield.value;
        if (!raw) return;
        var blocks = JSON.parse(raw);
        if (!Array.isArray(blocks)) return;
        var productId = Number(cfg.productId);
        var vacuumProductId = 16280458330457;
        var configEl = document.querySelector('.product-bundle-upsell[data-pdp-type="backpack"] [data-bundle-config]');
        if (configEl) {
          try {
            var localConfig = JSON.parse(configEl.textContent);
            if (localConfig.vacuumProductId) vacuumProductId = Number(localConfig.vacuumProductId);
          } catch (e) { /* keep fallback */ }
        }

        blocks.forEach(function (block) {
          var ids = block.selectedProductIds || [];
          var matchesProduct = ids.some(function (id) { return Number(id) === productId; });
          if (!matchesProduct || !block.dealBars) return;
          block.dealBars.forEach(function (bar) {
            if (bar.dealBarType !== 'bundle' || !bar.bundleProducts) return;
            var slot = null;
            bar.bundleProducts.forEach(function (product) {
              if (!product.productGID || product.productGID === 'default') return;
              if (gidToId(product.productGID) === vacuumProductId) slot = product;
            });
            if (!slot) {
              bar.bundleProducts.forEach(function (product) {
                if (product.productGID && product.productGID !== 'default') slot = product;
              });
            }
            if (!slot) return;
            var allowed = null;
            if (slot.variantGIDs && slot.variantGIDs.length) {
              allowed = slot.variantGIDs.map(gidToId).filter(Boolean);
            }
            backpackKachingDeal = {
              deal: block.nanoId || block.id,
              versionId: block.versionId || null,
              barId: bar.id,
              bundleProductId: slot.id,
              pageProductId: productId,
              allowedVariantIds: allowed
            };
          });
        });
        document.dispatchEvent(new CustomEvent('backpack-kaching-deal:ready'));
      })
      .catch(function () {});
  }

  function initBundleUpsell(container) {
    var configEl = container.querySelector('[data-bundle-config]');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var formId = container.dataset.formId;
    var productId = container.dataset.productId;
    var selectedOption = container.dataset.defaultSelection || 'overpacker';
    var selectedVacuumVariantId = null;
    var selectedVacuumColor = '';
    var selectedVacuumPack = '';
    var selectedWeekenderVariantId = parseInt(config.weekenderVariantId, 10) ||
      parseInt(container.dataset.weekenderVariantId, 10) ||
      null;
    var selectedBogoWeekenderVariantId = null;
    var packsMode = isTravelsetPacksAb();

    function buildListFromSwatches(selector, idAttr) {
      var list = [];
      idAttr = idAttr || 'data-vacuum-variant-id';
      container.querySelectorAll(selector).forEach(function (s) {
        var id = parseInt(s.getAttribute(idAttr), 10);
        if (!id) return;
        if (idAttr === 'data-bogo-weekender-variant-id') {
          list.push({
            id: id,
            price: parseInt(s.getAttribute('data-bogo-weekender-price'), 10) || 0,
            second_price: parseInt(s.getAttribute('data-bogo-weekender-second-price'), 10) || 0,
            compare_at_price: parseInt(s.getAttribute('data-bogo-weekender-compare'), 10) || 0,
            image: s.getAttribute('data-bogo-weekender-image') || null,
            title: s.getAttribute('data-bogo-weekender-title') || '',
            color: s.getAttribute('data-bogo-weekender-color') || ''
          });
        } else {
          list.push({
            id: id,
            price: parseInt(s.getAttribute('data-vacuum-variant-price') || s.getAttribute('data-vacuum-price'), 10) || 0,
            compare_at_price: parseInt(s.getAttribute('data-vacuum-variant-compare') || s.getAttribute('data-vacuum-compare'), 10) || 0,
            image: s.getAttribute('data-vacuum-image') || null,
            title: s.getAttribute('data-vacuum-title') || '',
            pack: s.getAttribute('data-vacuum-pack') || '',
            color: s.getAttribute('data-vacuum-color') || ''
          });
        }
      });
      return list;
    }

    function getBogoSecondPrice(fullPrice) {
      var pct = parseInt(config.bogoSecondDiscountPercent, 10);
      if (isNaN(pct) || pct < 0 || pct > 100) pct = 60;
      return Math.round(fullPrice * (100 - pct) / 100);
    }

    function getActiveVacuumList() {
      if (config.vacuumVariants && config.vacuumVariants.length) {
        return config.vacuumVariants;
      }
      return buildListFromSwatches('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch');
    }

    function getActiveBogoWeekenderList() {
      // Black-only: prefer configured BOGO black variant
      var blackId = parseInt(config.bogoWeekenderVariantId, 10);
      if (blackId && config.weekenderVariants && config.weekenderVariants.length) {
        for (var i = 0; i < config.weekenderVariants.length; i++) {
          var v = config.weekenderVariants[i];
          if (parseInt(v.id, 10) === blackId) {
            return [{
              id: v.id,
              price: v.price,
              second_price: getBogoSecondPrice(v.price),
              compare_at_price: v.compare_at_price,
              image: config.bogoWeekenderImage || v.image || null,
              title: v.title || '',
              color: v.color || 'Black'
            }];
          }
        }
      }
      if (blackId) {
        return [{
          id: blackId,
          price: config.weekenderPrice,
          second_price: getBogoSecondPrice(config.weekenderPrice),
          compare_at_price: config.bogoWeekenderComparePrice || config.weekenderComparePrice,
          image: config.bogoWeekenderImage || null,
          title: 'Black',
          color: 'Black'
        }];
      }
      if (config.weekenderVariants && config.weekenderVariants.length) {
        var blackOnly = config.weekenderVariants.filter(function (item) {
          return String(item.color || item.title || '').toLowerCase().indexOf('black') !== -1;
        });
        var source = blackOnly.length ? blackOnly : [config.weekenderVariants[0]];
        return source.map(function (item) {
          return {
            id: item.id,
            price: item.price,
            second_price: getBogoSecondPrice(item.price),
            compare_at_price: item.compare_at_price,
            image: item.image || null,
            title: item.title || '',
            color: item.color || ''
          };
        });
      }
      return [];
    }

    function getActiveSwatches() {
      if (packsMode) {
        // No color swatches for Weekender BOGO (Black only)
        return [];
      }
      return container.querySelectorAll('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch');
    }

    var activeList = getActiveVacuumList();
    if (activeList.length > 0) {
      selectedVacuumVariantId = activeList[0].id;
    }
    if (usesVacuumMatrix()) {
      var initialColorSwatch = container.querySelector('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch.is-selected') ||
        container.querySelector('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch');
      selectedVacuumColor = initialColorSwatch ? (initialColorSwatch.getAttribute('data-vacuum-color') || '') : (config.vacuumAllVariants[0].color || '');
      selectedVacuumPack = '1 Pack';
      applyVacuumMatrixSelection();
    }
    var bogoList = getActiveBogoWeekenderList();
    if (bogoList.length > 0) {
      selectedBogoWeekenderVariantId = bogoList[0].id;
    }

    var optionCards = container.querySelectorAll('[data-bundle-option]');
    var swatches = getActiveSwatches();

    function usesVacuumMatrix() {
      return !!(config.isBackpackPdp && config.vacuumAllVariants && config.vacuumAllVariants.length);
    }

    function normalizeOption(value) {
      return String(value || '').toLowerCase().trim();
    }

    function vacuumVariantAllowed(variant) {
      var allowed = backpackKachingDeal && backpackKachingDeal.allowedVariantIds;
      if (!allowed || !allowed.length || !variant) return true;
      return allowed.indexOf(parseInt(variant.id, 10)) !== -1;
    }

    function resolveVacuumVariant(color, pack) {
      var all = (config.vacuumAllVariants || []).filter(vacuumVariantAllowed);
      var colorKey = normalizeOption(color);
      var packKey = normalizeOption(pack);
      var i;
      for (i = 0; i < all.length; i++) {
        if (normalizeOption(all[i].color) === colorKey && normalizeOption(all[i].pack) === packKey) {
          return all[i];
        }
      }
      for (i = 0; i < all.length; i++) {
        if (normalizeOption(all[i].color) === colorKey) return all[i];
      }
      return all[0] || null;
    }

    function syncVacuumMatrixUi() {
      container.querySelectorAll('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch').forEach(function (s) {
        var active = normalizeOption(s.getAttribute('data-vacuum-color')) === normalizeOption(selectedVacuumColor);
        s.classList.toggle('is-selected', active);
        s.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    function applyVacuumMatrixSelection() {
      if (!usesVacuumMatrix()) return null;
      var variant = resolveVacuumVariant(selectedVacuumColor, selectedVacuumPack);
      if (!variant) return null;
      selectedVacuumVariantId = parseInt(variant.id, 10);
      selectedVacuumColor = variant.color || selectedVacuumColor;
      selectedVacuumPack = '1 Pack';
      syncVacuumMatrixUi();
      return variant;
    }

    function getSelectedVacuumVariant() {
      if (usesVacuumMatrix()) {
        var resolved = resolveVacuumVariant(selectedVacuumColor, selectedVacuumPack);
        if (resolved) return resolved;
      }

      var selectedSwatch =
        container.querySelector('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch.is-selected') ||
        container.querySelector('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch');

      if (selectedSwatch && selectedSwatch.getAttribute('data-vacuum-variant-id')) {
        return {
          id: parseInt(selectedSwatch.getAttribute('data-vacuum-variant-id'), 10),
          price: parseInt(selectedSwatch.getAttribute('data-vacuum-variant-price') || selectedSwatch.getAttribute('data-vacuum-price'), 10) || 0,
          compare_at_price: parseInt(selectedSwatch.getAttribute('data-vacuum-variant-compare') || selectedSwatch.getAttribute('data-vacuum-compare'), 10) || 0,
          image: selectedSwatch.getAttribute('data-vacuum-image') || null,
          title: selectedSwatch.getAttribute('data-vacuum-title') || '',
          pack: selectedSwatch.getAttribute('data-vacuum-pack') || '',
          color: selectedSwatch.getAttribute('data-vacuum-color') || ''
        };
      }

      var list = getActiveVacuumList();
      if (!list.length) return null;
      for (var i = 0; i < list.length; i++) {
        if (parseInt(list[i].id, 10) === parseInt(selectedVacuumVariantId, 10)) {
          return list[i];
        }
      }
      return list[0];
    }

    function getSelectedBogoWeekender() {
      var list = getActiveBogoWeekenderList();
      if (list.length) {
        selectedBogoWeekenderVariantId = list[0].id;
        return list[0];
      }
      var blackId = parseInt(config.bogoWeekenderVariantId, 10) || parseInt(config.weekenderVariantId, 10);
      return {
        id: blackId,
        price: config.weekenderPrice,
        second_price: getBogoSecondPrice(config.weekenderPrice),
        compare_at_price: config.bogoWeekenderComparePrice || config.weekenderComparePrice,
        image: config.bogoWeekenderImage || null,
        title: 'Black',
        color: 'Black'
      };
    }

    function getSelectedWeekender() {
      var list = config.weekenderVariants || [];
      if (!list.length) {
        return {
          id: selectedWeekenderVariantId || config.weekenderVariantId,
          price: config.weekenderPrice,
          compare_at_price: config.weekenderComparePrice,
          image: null,
          title: '',
          color: ''
        };
      }
      for (var i = 0; i < list.length; i++) {
        if (parseInt(list[i].id, 10) === parseInt(selectedWeekenderVariantId, 10)) {
          return list[i];
        }
      }
      return list[0];
    }

    function isInfograph01Src(src) {
      return /Infograph01/i.test(String(src || ''));
    }

    function getBackpackSafePackImageSrc() {
      var list = config.weekenderVariants || [];
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].image && !isInfograph01Src(list[i].image) && /Infograph03/i.test(list[i].image)) {
          return list[i].image;
        }
      }
      for (i = 0; i < list.length; i++) {
        if (list[i].image && !isInfograph01Src(list[i].image)) {
          return list[i].image;
        }
      }
      var mainImg = container.querySelector('.product-bundle-upsell__bundle-item-image img[data-weekender-image]');
      if (mainImg && mainImg.getAttribute('src') && !isInfograph01Src(mainImg.getAttribute('src'))) {
        return mainImg.getAttribute('src');
      }
      return null;
    }

    /**
     * Color swatches must show variant <img> (never price text).
     * Backpack PDP: force backpack product photo on bag thumb + swatches; lock vacuum thumb.
     */
    function ensureWeekenderSwatchImages() {
      if (config.isBackpackPdp) {
        var bagImg = container.querySelector('.product-bundle-upsell__bundle-item-image img[data-weekender-image]');
        if (bagImg && config.backpackBundleImage) bagImg.src = config.backpackBundleImage;
      }

      container.querySelectorAll('.product-bundle-upsell__swatches--weekender .product-bundle-upsell__swatch').forEach(function (swatch) {
        var src = swatch.getAttribute('data-weekender-image') || '';
        if (config.isBackpackPdp && config.backpackBundleImage) {
          src = config.backpackBundleImage;
          swatch.setAttribute('data-weekender-image', src);
        }
        if (!src) return;

        Array.prototype.slice.call(swatch.childNodes).forEach(function (node) {
          if (node.nodeType === 3) swatch.removeChild(node);
        });

        var img = swatch.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.width = 32;
          img.height = 32;
          img.loading = 'lazy';
          img.alt = swatch.getAttribute('aria-label') || config.weekenderTitle || 'Color';
          swatch.appendChild(img);
        }
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      });

      // Vacuum color swatches: keep <img> from data-vacuum-image
      container.querySelectorAll('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch').forEach(function (swatch) {
        var src = swatch.getAttribute('data-vacuum-image') || '';
        if (!src) return;
        Array.prototype.slice.call(swatch.childNodes).forEach(function (node) {
          if (node.nodeType === 3) swatch.removeChild(node);
        });
        var img = swatch.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.width = 28;
          img.height = 28;
          img.loading = 'lazy';
          img.alt = swatch.getAttribute('aria-label') || 'Color';
          swatch.appendChild(img);
        }
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      });
    }

    function fixBackpackInfographSwatches() {
      ensureWeekenderSwatchImages();
    }

    function applySelectedWeekenderToConfig() {
      var weekender = getSelectedWeekender();
      if (!weekender || !weekender.id) return weekender;

      selectedWeekenderVariantId = parseInt(weekender.id, 10);
      config.weekenderVariantId = selectedWeekenderVariantId;
      config.weekenderPrice = parseInt(weekender.price, 10) || config.weekenderPrice;
      config.weekenderComparePrice = parseInt(weekender.compare_at_price, 10) ||
        config.weekenderComparePrice ||
        config.weekenderPrice;
      container.dataset.weekenderVariantId = String(selectedWeekenderVariantId);

      var imageEl = container.querySelector('.product-bundle-upsell__bundle-item-image img[data-weekender-image]');
      var nextImage = weekender.image;
      if (config.isBackpackPdp && config.backpackBundleImage) {
        nextImage = config.backpackBundleImage;
      } else if (config.isBackpackPdp && isInfograph01Src(nextImage)) {
        nextImage = getBackpackSafePackImageSrc() || nextImage;
      }
      if (imageEl && nextImage && imageEl.getAttribute('data-backpack-locked-image') !== 'true') {
        imageEl.src = nextImage;
      } else if (imageEl && config.isBackpackPdp && config.backpackBundleImage) {
        imageEl.src = config.backpackBundleImage;
      }

      var labelEl = container.querySelector('[data-weekender-variant-label]');
      if (labelEl) labelEl.textContent = weekender.title || weekender.color || '';

      container.querySelectorAll('.product-bundle-upsell__swatches--weekender .product-bundle-upsell__swatch').forEach(function (s) {
        var active = parseInt(s.getAttribute('data-weekender-variant-id'), 10) === selectedWeekenderVariantId;
        s.classList.toggle('is-selected', active);
        s.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      fixBackpackInfographSwatches();
      syncWeekenderGallery(weekender.color || weekender.title);

      return weekender;
    }

    function slideGalleryColor(slide) {
      var marked = String(slide.getAttribute('data-gallery-color') || '').toLowerCase().trim();
      if (marked) return marked;
      var image = slide.querySelector('img');
      return image && image.alt ? String(image.alt).toLowerCase().trim() : '';
    }

    function isGalleryVideo(slide) {
      var type = slide.getAttribute('data-media-type') || '';
      return type === 'video' || type === 'external_video' || slideGalleryColor(slide) === 'shared';
    }

    function stampOriginalIndex(nodes) {
      nodes.forEach(function (node, index) {
        if (!node.hasAttribute('data-original-index')) {
          node.setAttribute('data-original-index', String(index));
        }
      });
    }

    function sortByOriginalIndex(nodes) {
      return nodes.slice().sort(function (a, b) {
        return parseInt(a.getAttribute('data-original-index'), 10) - parseInt(b.getAttribute('data-original-index'), 10);
      });
    }

    function bindWeekenderThumbClicks(dots) {
      if (dots._weekenderThumbBound) return;
      dots._weekenderThumbBound = true;
      dots.addEventListener('click', function (event) {
        var button = event.target.closest('button');
        if (!button || button.parentElement !== dots) return;
        var index = Array.prototype.indexOf.call(dots.children, button);
        if (index < 0 || button.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var carousel = document.getElementById(dots.getAttribute('aria-controls'));
        if (carousel && typeof carousel.select === 'function') {
          carousel.select(index, { animate: true });
        }
      }, true);
    }

    function applyWeekenderGalleryColor(color) {
      var wanted = String(color || '').toLowerCase().trim();
      if (!wanted) return;

      document.querySelectorAll('product-gallery').forEach(function (gallery) {
        var carousel = gallery.querySelector('media-carousel');
        if (!carousel) return;

        var slides = Array.prototype.slice.call(carousel.children).filter(function (node) {
          return node.classList && node.classList.contains('product-gallery__media');
        });
        if (!slides.length) return;
        stampOriginalIndex(slides);
        slides = sortByOriginalIndex(slides);

        var colorImages = slides.filter(function (slide) {
          return !isGalleryVideo(slide) && slideGalleryColor(slide) === wanted;
        });
        var sequence = [];
        var imageCursor = 0;

        slides.forEach(function (slide) {
          if (isGalleryVideo(slide)) {
            sequence.push(slide);
            return;
          }
          if (slideGalleryColor(slide) !== 'black') return;
          if (wanted === 'black') {
            sequence.push(slide);
            return;
          }
          if (colorImages[imageCursor]) {
            sequence.push(colorImages[imageCursor]);
            imageCursor += 1;
          }
        });

        while (wanted !== 'black' && imageCursor < colorImages.length) {
          sequence.push(colorImages[imageCursor]);
          imageCursor += 1;
        }

        sequence.forEach(function (slide) {
          slide.hidden = false;
          carousel.appendChild(slide);
        });
        slides.forEach(function (slide) {
          if (sequence.indexOf(slide) === -1) {
            slide.hidden = true;
            carousel.appendChild(slide);
          }
        });

        gallery.querySelectorAll('page-dots').forEach(function (dots) {
          var buttons = Array.prototype.slice.call(dots.children).filter(function (node) {
            return node.tagName === 'BUTTON';
          });
          stampOriginalIndex(buttons);
          var byOriginal = {};
          buttons.forEach(function (button) {
            byOriginal[button.getAttribute('data-original-index')] = button;
          });
          sequence.forEach(function (slide) {
            var button = byOriginal[slide.getAttribute('data-original-index')];
            if (!button) return;
            button.hidden = false;
            dots.appendChild(button);
          });
          buttons.forEach(function (button) {
            var used = sequence.some(function (slide) {
              return slide.getAttribute('data-original-index') === button.getAttribute('data-original-index');
            });
            if (!used) {
              button.hidden = true;
              dots.appendChild(button);
            }
          });
          dots.items = Array.prototype.slice.call(dots.children);
          if (dots.items[0] && typeof dots.select === 'function') dots.select(0, false);
          bindWeekenderThumbClicks(dots);
        });

        carousel._items = null;
        carousel._selectedIndex = 0;
        if (typeof carousel.select === 'function') {
          carousel.select(0, { animate: false, force: true });
        }
      });
    }

    function optionInputColor(input) {
      if (!input) return '';
      var inputId = input.id && window.CSS && CSS.escape ? CSS.escape(input.id) : input.id;
      var label = inputId ? document.querySelector('label[for="' + inputId + '"]') : null;
      if (!label && input.nextElementSibling && input.nextElementSibling.matches && input.nextElementSibling.matches('label')) {
        label = input.nextElementSibling;
      }
      if (!label) return '';
      var srOnly = label.querySelector('.sr-only');
      return String((srOnly || label).textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function clickWeekenderColorOption(color) {
      var wanted = String(color || '').toLowerCase().trim();
      if (!wanted) return;
      var handle = config.pdpHandle || 'weekender';
      var picker = document.querySelector('variant-picker[handle="' + handle + '"][update-url]') ||
        document.querySelector('variant-picker[handle="' + handle + '"]');
      if (!picker) return;

      var inputs = picker.querySelectorAll('input[data-option-position]');
      var match = null;
      for (var i = 0; i < inputs.length; i++) {
        if (optionInputColor(inputs[i]) === wanted) {
          match = inputs[i];
          break;
        }
      }
      if (!match || match.checked) return;
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncWeekenderGallery(color) {
      if (container.dataset.pdpType !== 'weekender' || !color) return;
      applyWeekenderGalleryColor(color);
      clickWeekenderColorOption(color);
      clearTimeout(container._weekenderGalleryTimer);
      container._weekenderGalleryTimer = setTimeout(function () {
        applyWeekenderGalleryColor(color);
      }, 600);
    }

    function syncPacksModeUi() {
      packsMode = isTravelsetPacksAb();
      document.documentElement.classList.toggle('travelset-packs-ab--active', packsMode);
      if (document.body) {
        document.body.classList.toggle('travelset-packs-ab--active', packsMode);
      }

      if (packsMode) {
        bogoList = getActiveBogoWeekenderList();
        if (bogoList.length > 0) {
          var stillValid = false;
          for (var i = 0; i < bogoList.length; i++) {
            if (parseInt(bogoList[i].id, 10) === parseInt(selectedBogoWeekenderVariantId, 10)) {
              stillValid = true;
              break;
            }
          }
          if (!stillValid) selectedBogoWeekenderVariantId = bogoList[0].id;
        }
        swatches = getActiveSwatches();
        swatches.forEach(function (s) {
          var active = parseInt(s.getAttribute('data-bogo-weekender-variant-id'), 10) === parseInt(selectedBogoWeekenderVariantId, 10);
          s.classList.toggle('is-selected', active);
          s.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      } else {
        applySelectedWeekenderToConfig();
        activeList = getActiveVacuumList();
        if (activeList.length > 0) {
          var stillValidV = false;
          for (var j = 0; j < activeList.length; j++) {
            if (parseInt(activeList[j].id, 10) === parseInt(selectedVacuumVariantId, 10)) {
              stillValidV = true;
              break;
            }
          }
          if (!stillValidV) selectedVacuumVariantId = activeList[0].id;
        }
        swatches = getActiveSwatches();
        if (usesVacuumMatrix()) {
          applyVacuumMatrixSelection();
        } else {
          swatches.forEach(function (s) {
            var active = parseInt(s.getAttribute('data-vacuum-variant-id'), 10) === parseInt(selectedVacuumVariantId, 10);
            s.classList.toggle('is-selected', active);
            s.setAttribute('aria-checked', active ? 'true' : 'false');
          });
        }
      }
      if (selectedOption === 'overpacker') updateBundleTotalPrice();
    }

    function syncFormVariant() {
      if (!getAbEnabled()) return;
      if (container.dataset.pdpType !== 'vacuum-kit') return;

      var form = getProductForm(formId);
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      if (selectedOption === 'overpacker' && selectedVacuumVariantId) {
        idInput.value = selectedVacuumVariantId;
        idInput.disabled = false;
      }
    }

    // Shop-currency amount for the bundle vacuum kit ($50). Variant prices in the
    // config are already in the active currency, so this fixed amount is converted
    // with Shopify.currency.rate before it is shown.
    var BACKPACK_VACUUM_SHOP_CENTS = 5000;

    function presentmentFromShopCents(shopCents) {
      var rate = 1;
      if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
        var parsed = parseFloat(Shopify.currency.rate);
        if (parsed > 0) rate = parsed;
      }
      return Math.round(Number(shopCents) * rate);
    }

    function backpackVacuumDisplayCents() {
      return presentmentFromShopCents(BACKPACK_VACUUM_SHOP_CENTS);
    }

    function getOverpackerDiscountAmount() {
      if (packsMode) return 0;
      if (config.isBackpackPdp) return 0;
      return config.overpackerDiscountAmount || 0;
    }

    function getOverpackerDiscountedTotal(rawTotal) {
      if (config.isBackpackPdp) {
        return (parseInt(config.weekenderPrice, 10) || 0) + backpackVacuumDisplayCents();
      }
      var discount = getOverpackerDiscountAmount();
      if (!discount || !getAbEnabled()) return rawTotal;
      return Math.max(0, rawTotal - discount);
    }

    function getDiscountCode() {
      packsMode = isTravelsetPacksAb();
      if (!getAbEnabled() || selectedOption !== 'overpacker') return null;
      // Buy1Get1: no discount code — just add 2 weekenders
      if (packsMode) return null;
      // Backpack Pack More Bundle is UI-only — Kaching owns discount codes
      if (config.isBackpackPdp) return null;
      var code = config.overpackerDiscountCode || null;
      if (code && String(code).toUpperCase() === BACKPACK_BUNDLE_CODE) {
        return WEEKENDER_BUNDLE_CODE;
      }
      return code;
    }

    function getOverpackerItemPrices(vacuum) {
      if (config.isBackpackPdp) {
        return {
          weekender: parseInt(config.weekenderPrice, 10) || 0,
          vacuum: backpackVacuumDisplayCents()
        };
      }
      if (!vacuum) {
        return { weekender: config.weekenderPrice, vacuum: 0 };
      }
      var rawTotal = config.weekenderPrice + vacuum.price;
      var discount = getOverpackerDiscountAmount();
      if (!discount || !getAbEnabled()) {
        return { weekender: config.weekenderPrice, vacuum: vacuum.price };
      }
      var weekenderShare = Math.round(discount * (config.weekenderPrice / rawTotal));
      var weekenderDisplay = config.weekenderPrice - weekenderShare;
      var vacuumDisplay = rawTotal - discount - weekenderDisplay;
      return {
        weekender: weekenderDisplay,
        vacuum: vacuumDisplay
      };
    }

    function formatSaveAmount(cents) {
      var rounded = Math.round(Number(cents) || 0);
      if (rounded < 1) return '';
      var formatted = formatMoney(rounded, config.moneyFormat);
      if (!formatted) return '';
      return 'Save ' + formatted.replace(/\.00$/, '');
    }

    function updateOverpackerHeaderBadge(displayPrice, comparePrice) {
      var badgeEl = container.querySelector('[data-bundle-discount-badge]');
      var bogoBadgeEl = container.querySelector('[data-bogo-discount-badge]');
      if (packsMode) {
        if (badgeEl) badgeEl.hidden = true;
        if (bogoBadgeEl) bogoBadgeEl.hidden = true;
        return;
      }
      if (bogoBadgeEl) bogoBadgeEl.hidden = true;
      if (!badgeEl) return;
      if (comparePrice > displayPrice) {
        var saveCents = comparePrice - displayPrice;
        if (config.isBackpackPdp) {
          var saveLabel = formatSaveAmount(saveCents);
          badgeEl.textContent = saveLabel || '';
          badgeEl.hidden = !saveLabel;
        } else {
          var pct = Math.round((saveCents / comparePrice) * 100);
          badgeEl.textContent = pct + '% OFF';
          badgeEl.hidden = false;
        }
      } else {
        badgeEl.hidden = true;
      }
    }

    function setDiscountBadge(badgeEl, compareCents, priceCents) {
      if (!badgeEl) return;
      var compare = parseInt(compareCents, 10) || 0;
      var price = parseInt(priceCents, 10) || 0;
      // Backpack: use list price when compare_at is missing (shows "Save $13")
      if (
        config.isBackpackPdp &&
        compare <= price &&
        config.weekenderPrice &&
        badgeEl.hasAttribute('data-weekender-discount-badge')
      ) {
        compare = parseInt(config.weekenderPrice, 10) || compare;
      }
      if (compare > price && compare > 0) {
        if (config.isBackpackPdp) {
          var saveLabel = formatSaveAmount(compare - price);
          if (saveLabel) {
            badgeEl.textContent = saveLabel;
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        } else {
          var pct = Math.round(((compare - price) / compare) * 100);
          badgeEl.textContent = pct + '% OFF';
          badgeEl.hidden = false;
        }
      } else {
        badgeEl.hidden = true;
      }
    }

    function getBogoDisplayEachPrice() {
      var fixed = parseInt(config.bogoDisplayEachPrice, 10);
      if (!isNaN(fixed) && fixed > 0) return fixed;
      return 9800;
    }

    function updateBogoBundlePrices() {
      var second = getSelectedBogoWeekender();
      var eachPrice = getBogoDisplayEachPrice();
      var compareEach = config.bogoWeekenderComparePrice || config.weekenderComparePrice;
      var headerPriceText = formatMoney(eachPrice, config.moneyFormat) + ' Each';

      var priceEl = container.querySelector('[data-bogo-header-price]') ||
        container.querySelector('[data-bundle-total-price]');
      var compareEl = container.querySelector('[data-bogo-header-compare]');
      var controlCompareEl = container.querySelector('[data-bundle-total-compare]');
      if (priceEl) priceEl.textContent = headerPriceText;
      if (compareEl) compareEl.hidden = true;
      if (controlCompareEl) controlCompareEl.hidden = true;

      updateOverpackerHeaderBadge(eachPrice, compareEach);

      var weekenderPriceEl = container.querySelector('.product-bundle-upsell__price[data-weekender-price]');
      var weekenderCompareEl = container.querySelector('.product-bundle-upsell__compare[data-weekender-compare]');
      if (weekenderPriceEl) weekenderPriceEl.textContent = formatMoney(eachPrice, config.moneyFormat);
      if (weekenderCompareEl) weekenderCompareEl.textContent = formatMoney(compareEach, config.moneyFormat);

      var weekenderBadgeEl = container.querySelector('[data-weekender-discount-badge]');
      if (weekenderBadgeEl) weekenderBadgeEl.hidden = true;

      var bogoPriceEl = container.querySelector('.product-bundle-upsell__price[data-bogo-weekender-price]');
      var bogoCompareEl = container.querySelector('.product-bundle-upsell__compare[data-bogo-weekender-compare]');
      if (bogoPriceEl) bogoPriceEl.textContent = formatMoney(eachPrice, config.moneyFormat);
      if (bogoCompareEl) bogoCompareEl.textContent = formatMoney(second.compare_at_price || compareEach, config.moneyFormat);

      var blackImage = config.bogoWeekenderImage || (second && second.image) || null;
      var bogoImageEl = container.querySelector('[data-bogo-weekender-image]');
      if (bogoImageEl && blackImage) bogoImageEl.src = blackImage;

      var weekenderRowImg = container.querySelector('.product-bundle-upsell__bundle-details .product-bundle-upsell__bundle-item:first-child .product-bundle-upsell__bundle-item-image img');
      if (weekenderRowImg && blackImage) weekenderRowImg.src = blackImage;

      var bogoBadgeEl = container.querySelector('[data-bogo-weekender-discount-badge]');
      if (bogoBadgeEl) bogoBadgeEl.hidden = true;

      ensureWeekenderSwatchImages();
      syncFormVariant();
      updateBuyButtonPrice();
    }

    function updateBundleTotalPrice() {
      if (packsMode) {
        updateBogoBundlePrices();
        return;
      }

      var vacuum = getSelectedVacuumVariant();
      if (!vacuum) return;

      var total = config.weekenderPrice + vacuum.price;
      var compareTotal = config.weekenderComparePrice + vacuum.compare_at_price;
      var displayTotal = getOverpackerDiscountedTotal(total);

      var priceEl = container.querySelector('[data-bundle-total-price]');
      var compareEl = container.querySelector('[data-bundle-total-compare]');

      if (priceEl) priceEl.textContent = formatMoney(displayTotal, config.moneyFormat);
      if (compareEl) {
        compareEl.textContent = formatMoney(compareTotal, config.moneyFormat);
        compareEl.hidden = false;
      }

      updateOverpackerHeaderBadge(displayTotal, compareTotal);

      var itemPrices = getOverpackerItemPrices(vacuum);
      var weekenderPriceEl = container.querySelector('.product-bundle-upsell__price[data-weekender-price]');
      var weekenderCompareEl = container.querySelector('.product-bundle-upsell__compare[data-weekender-compare]');
      if (weekenderPriceEl) weekenderPriceEl.textContent = formatMoney(itemPrices.weekender, config.moneyFormat);
      if (weekenderCompareEl) weekenderCompareEl.textContent = formatMoney(config.weekenderComparePrice, config.moneyFormat);

      var vacuumPriceEl = container.querySelector('.product-bundle-upsell__price[data-vacuum-price]');
      var vacuumCompareEl = container.querySelector('.product-bundle-upsell__compare[data-vacuum-compare]');
      if (vacuumPriceEl) vacuumPriceEl.textContent = formatMoney(itemPrices.vacuum, config.moneyFormat);
      if (vacuumCompareEl) vacuumCompareEl.textContent = formatMoney(vacuum.compare_at_price, config.moneyFormat);

      var vacuumImageEl = container.querySelector('.product-bundle-upsell__bundle-item-image img[data-vacuum-image]');
      if (vacuumImageEl && vacuum.image) {
        vacuumImageEl.src = vacuum.image;
      }

      var labelEl = container.querySelector('[data-vacuum-variant-label]');
      if (labelEl && vacuum.title) labelEl.textContent = vacuum.title;

      var badgeEl = container.querySelector('[data-vacuum-discount-badge]');
      setDiscountBadge(badgeEl, vacuum.compare_at_price, itemPrices.vacuum);

      var weekenderBadgeEl = container.querySelector('[data-weekender-discount-badge]');
      if (config.isBackpackPdp) {
        if (weekenderBadgeEl) weekenderBadgeEl.hidden = true;
        if (weekenderCompareEl) weekenderCompareEl.hidden = true;
      } else {
        setDiscountBadge(weekenderBadgeEl, config.weekenderComparePrice, itemPrices.weekender);
      }

      ensureWeekenderSwatchImages();
      syncFormVariant();
      updateBuyButtonPrice();
    }

    var priceSyncLock = false;
    var priceSyncDelayedTimer = null;
    var lastSyncedButtonPrice = '';
    var lastSyncedButtonCompare = '';

    function isBundleLockedNode(node) {
      if (!node || node.nodeType !== 1) {
        if (node && node.parentElement) {
          return node.parentElement.getAttribute('data-bundle-price-locked') === 'true';
        }
        return false;
      }
      return node.getAttribute('data-bundle-price-locked') === 'true' ||
        !!(node.closest && node.closest('[data-bundle-price-locked="true"]'));
    }

    function updateBuyButtonPrice() {
      if (!getAbEnabled() || priceSyncLock) return;
      priceSyncLock = true;

      try {
        var price;
        var comparePrice;

        if (selectedOption === 'single') {
          price = config.weekenderPrice;
          comparePrice = config.weekenderComparePrice;
        } else if (packsMode) {
          var eachDisplay = getBogoDisplayEachPrice();
          price = eachDisplay * 2;
          comparePrice = config.weekenderComparePrice * 2;
        } else {
          var vacuum = getSelectedVacuumVariant();
          var rawTotal = config.weekenderPrice + (vacuum ? vacuum.price : 0);
          comparePrice = config.weekenderComparePrice + (vacuum ? vacuum.compare_at_price : 0);
          price = getOverpackerDiscountedTotal(rawTotal);
        }

        var formattedPrice = formatMoney(price, config.moneyFormat);
        var formattedCompare = formatMoney(comparePrice, config.moneyFormat);
        var formattedCompareDisplay = comparePrice > price ? formattedCompare : '';

        function updatePriceEl(el) {
          if (el.closest('.product-bundle-upsell')) return;
          if (el.textContent !== formattedPrice) {
            el.textContent = formattedPrice;
          }
          el.setAttribute('data-bundle-price-locked', 'true');
        }

        function updateCompareEl(el) {
          if (el.closest('.product-bundle-upsell')) return;
          if (comparePrice > price) {
            if (el.textContent !== formattedCompare) {
              el.textContent = formattedCompare;
            }
            el.style.display = '';
            el.setAttribute('data-bundle-price-locked', 'true');
          } else if (el.style.display !== 'none') {
            el.style.display = 'none';
          }
        }

        document.querySelectorAll('.product-info__buy-buttons .buy-buttons__price, .product-info__buy-buttons .igPrice').forEach(updatePriceEl);
        document.querySelectorAll('.product-info__buy-buttons .buy-buttons__compare-price, .product-info__buy-buttons .igComparePrice').forEach(updateCompareEl);
        document.querySelectorAll('buy-buttons[form="' + formId + '"] .buy-buttons__price, buy-buttons[form="' + formId + '"] .igPrice').forEach(updatePriceEl);
        document.querySelectorAll('buy-buttons[form="' + formId + '"] .buy-buttons__compare-price, buy-buttons[form="' + formId + '"] .igComparePrice').forEach(updateCompareEl);

        var productForm = getProductForm(formId);
        if (productForm) {
          productForm.querySelectorAll('.buy-buttons__price, .buy-buttons .igPrice').forEach(updatePriceEl);
          productForm.querySelectorAll('.buy-buttons__compare-price, .buy-buttons .igComparePrice').forEach(updateCompareEl);
        }

        // Sticky ATC price (often still shows single $149 while Overpacker is $199)
        document.querySelectorAll('.sticky-atc__price, .sticky-atc .buy-buttons__price, .sticky-atc .igPrice').forEach(updatePriceEl);
        document.querySelectorAll('.sticky-atc__compare-price, .sticky-atc .buy-buttons__compare-price, .sticky-atc .igComparePrice').forEach(updateCompareEl);

        if (formattedPrice !== lastSyncedButtonPrice || formattedCompareDisplay !== lastSyncedButtonCompare) {
          lastSyncedButtonPrice = formattedPrice;
          lastSyncedButtonCompare = formattedCompareDisplay;
          document.dispatchEvent(new CustomEvent('bundle-selector:price-update', {
            bubbles: true,
            detail: {
              formId: formId,
              price: formattedPrice,
              comparePrice: formattedCompareDisplay,
              selectedOption: selectedOption
            }
          }));
        }
      } finally {
        priceSyncLock = false;
      }
    }

    function schedulePriceSync() {
      updateBuyButtonPrice();
      clearTimeout(priceSyncDelayedTimer);
      priceSyncDelayedTimer = setTimeout(updateBuyButtonPrice, 200);
    }

    var priceGuardObserver = null;
    function startBuyButtonPriceGuard() {
      if (priceGuardObserver) return;
      var target = document.querySelector('.product-info__buy-buttons');
      if (!target) return;
      var guardTimer;
      priceGuardObserver = new MutationObserver(function (mutations) {
        if (!getAbEnabled() || priceSyncLock) return;

        var shouldUpdate = false;
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          var mutationTarget = mutation.target;

          if (mutation.type === 'characterData' && isBundleLockedNode(mutationTarget)) {
            continue;
          }

          if (mutation.type === 'attributes' && mutation.attributeName === 'data-bundle-price-locked') {
            continue;
          }

          if (mutation.type === 'childList') {
            var addedNeedsSync = false;
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              if (node.matches && node.matches('[data-bundle-price-locked="true"]')) return;
              if (node.querySelector && !node.querySelector('.buy-buttons__price, .buy-buttons__compare-price, buy-buttons')) return;
              addedNeedsSync = true;
            });
            if (!addedNeedsSync && mutation.removedNodes.length === 0) {
              continue;
            }
          }

          shouldUpdate = true;
          break;
        }

        if (!shouldUpdate) return;
        clearTimeout(guardTimer);
        guardTimer = setTimeout(updateBuyButtonPrice, 50);
      });
      priceGuardObserver.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bundle-price-locked'] });
    }

    function stopBuyButtonPriceGuard() {
      if (priceGuardObserver) {
        priceGuardObserver.disconnect();
        priceGuardObserver = null;
      }
    }

    function selectOption(option) {
      selectedOption = option;
      optionCards.forEach(function (card) {
        var isSelected = card.dataset.bundleOption === option;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      syncFormVariant();
      // Backpack: Single Bag disables Kaching; Pack More Bundle keeps Kaching for real ATC
      if (config.isBackpackPdp) {
        neutralizeKachingForm();
      }
      if (option === 'overpacker') {
        updateBundleTotalPrice();
      } else {
        clearBundleDiscountIfActive();
        updateBuyButtonPrice();
      }
    }

    optionCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('.product-bundle-upsell__swatch')) return;
        selectOption(card.dataset.bundleOption);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (e.target.closest('.product-bundle-upsell__swatch')) return;
          selectOption(card.dataset.bundleOption);
        }
      });
    });

    function onSwatchClick(e) {
      e.stopPropagation();
      e.preventDefault();
      var swatch = e.currentTarget;

      if (swatch.hasAttribute('data-weekender-variant-id')) {
        selectedWeekenderVariantId = parseInt(swatch.getAttribute('data-weekender-variant-id'), 10);
        applySelectedWeekenderToConfig();
        var ownerCard = swatch.closest('[data-bundle-option]');
        selectOption(ownerCard && ownerCard.dataset.bundleOption ? ownerCard.dataset.bundleOption : 'overpacker');
        return;
      } else if (swatch.hasAttribute('data-bogo-weekender-variant-id')) {
        selectedBogoWeekenderVariantId = parseInt(swatch.getAttribute('data-bogo-weekender-variant-id'), 10);
        container.querySelectorAll('.product-bundle-upsell__swatches--weekender .product-bundle-upsell__swatch').forEach(function (s) {
          var active = s === swatch;
          s.classList.toggle('is-selected', active);
          s.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      } else if (usesVacuumMatrix() && swatch.getAttribute('data-vacuum-color')) {
        selectedVacuumColor = swatch.getAttribute('data-vacuum-color') || '';
        selectedVacuumPack = '1 Pack';
        applyVacuumMatrixSelection();
      } else {
        selectedVacuumVariantId = parseInt(swatch.getAttribute('data-vacuum-variant-id'), 10);
        container.querySelectorAll('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch').forEach(function (s) {
          var active = s === swatch;
          s.classList.toggle('is-selected', active);
          s.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      }

      updateBundleTotalPrice();
      selectOption('overpacker');
    }

    container.querySelectorAll('.product-bundle-upsell__swatch').forEach(function (swatch) {
      if (swatch._bundleSwatchBound) return;
      swatch._bundleSwatchBound = true;
      swatch.addEventListener('click', onSwatchClick);
    });

    function applyAllowedVacuumOptions() {
      if (!usesVacuumMatrix()) return;
      var allowed = backpackKachingDeal && backpackKachingDeal.allowedVariantIds;
      if (!allowed || !allowed.length) return;
      var all = config.vacuumAllVariants || [];
      function optionHasVariant(key, value) {
        return all.some(function (variant) {
          if (!vacuumVariantAllowed(variant)) return false;
          return normalizeOption(variant[key]) === normalizeOption(value);
        });
      }
      container.querySelectorAll('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch').forEach(function (swatch) {
        swatch.hidden = !optionHasVariant('color', swatch.getAttribute('data-vacuum-color'));
      });
      var visibleColor = container.querySelector('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch:not([hidden]).is-selected') ||
        container.querySelector('.product-bundle-upsell__swatches--colors .product-bundle-upsell__swatch:not([hidden])');
      if (visibleColor) selectedVacuumColor = visibleColor.getAttribute('data-vacuum-color') || selectedVacuumColor;
      selectedVacuumPack = '1 Pack';
      applyVacuumMatrixSelection();
      if (selectedOption === 'overpacker') updateBundleTotalPrice();
    }
    document.addEventListener('backpack-kaching-deal:ready', applyAllowedVacuumOptions);

    container._syncTravelsetPacksMode = syncPacksModeUi;
    syncPacksModeUi();
    fixBackpackInfographSwatches();

    function getBundleCartItems() {
      // Always re-read packs mode so ATC matches visible Buy1Get1 UI
      packsMode = isTravelsetPacksAb();

      var items = [];
      var weekenderId = parseInt(selectedWeekenderVariantId, 10) ||
        parseInt(config.weekenderVariantId, 10) ||
        parseInt(container.dataset.weekenderVariantId, 10);

      if (!weekenderId) {
        console.error('Bundle selector: weekender variant not configured');
        return items;
      }

      if (selectedOption === 'single') {
        items.push({ id: weekenderId, quantity: 1 });
      } else if (packsMode) {
        // Buy 1 Get 1 — always add 2× Black Weekender
        var black = getSelectedBogoWeekender();
        var blackId = black && black.id
          ? parseInt(black.id, 10)
          : (parseInt(config.bogoWeekenderVariantId, 10) || weekenderId);
        items.push({ id: blackId, quantity: 2 });
      } else if (config.isBackpackPdp) {
        var vacuumForCart = getSelectedVacuumVariant();
        var vacuumCartId = vacuumForCart && vacuumForCart.id
          ? parseInt(vacuumForCart.id, 10)
          : parseInt(selectedVacuumVariantId, 10);
        items = buildBackpackBundleCartItems(weekenderId, vacuumCartId);
      } else {
        items.push({ id: weekenderId, quantity: 1 });
        if (selectedVacuumVariantId) {
          items.push({ id: parseInt(selectedVacuumVariantId, 10), quantity: 1 });
        }
      }

      return items;
    }

    function mergeWithCheckedAddons(bundleItems) {
      var items = bundleItems.slice();
      getCheckedAddonVariantIds(productId).forEach(function (id) {
        if (!items.some(function (x) { return x.id === id; })) {
          items.push({ id: id, quantity: 1 });
        }
      });
      return items;
    }

    function shouldOpenAddonPopup() {
      return !isMobile() &&
        document.getElementById('addon-popup-overlay') &&
        window.ADDON_POPUP &&
        window.ADDON_POPUP.enabled &&
        window.ADDON_POPUP.products &&
        window.ADDON_POPUP.products.length > 0;
    }

    function processAtc(submitBtn, targetForm) {
      if (!getAbEnabled()) return false;
      if (!submitBtn || !targetForm || getFormId(targetForm) !== formId) return false;

      packsMode = isTravelsetPacksAb();

      var bundleItems = getBundleCartItems();

      if (bundleItems.length === 0) {
        // Still claim the submit (return true) so we don't double-fire native ATC,
        // but clear busy — previously CustomButton spinner never recovered.
        console.error('Bundle selector: empty cart items for form', formId);
        if (submitBtn) {
          submitBtn.removeAttribute('aria-busy');
          submitBtn.disabled = false;
        }
        alert('Could not add to cart. Please refresh the page and try again.');
        return true;
      }

      // Buy1Get1 must always send 2 weekenders (qty 2 or 2 line items)
      if (packsMode && selectedOption === 'overpacker') {
        var totalQty = bundleItems.reduce(function (sum, item) {
          return sum + (parseInt(item.quantity, 10) || 0);
        }, 0);
        if (totalQty < 2) {
          var fallbackId = parseInt(config.bogoWeekenderVariantId, 10) ||
            parseInt(config.weekenderVariantId, 10) ||
            parseInt(container.dataset.weekenderVariantId, 10);
          if (fallbackId) {
            bundleItems = [{ id: fallbackId, quantity: 2 }];
          }
        }
      }

      window.BUNDLE_SELECTOR_PENDING = { items: bundleItems, formId: formId };

      if (isMobile()) {
        addItemsToCart(mergeWithCheckedAddons(bundleItems), submitBtn, productId, getDiscountCode());
        return true;
      }

      if (shouldOpenAddonPopup()) {
        document.dispatchEvent(new CustomEvent('addon-popup:open', {
          bubbles: true,
          detail: { form: targetForm }
        }));

        var overlay = document.getElementById('addon-popup-overlay');
        if (!overlay || !overlay.classList.contains('is-open')) {
          addItemsToCart(mergeWithCheckedAddons(bundleItems), submitBtn, productId, getDiscountCode());
        }
        return true;
      }

      addItemsToCart(mergeWithCheckedAddons(bundleItems), submitBtn, productId, getDiscountCode());
      return true;
    }

    function resetToVariantPicker() {
      var form = getProductForm(formId);
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var checked = document.querySelector(
        '.product-info__variant-picker input[type="radio"]:checked, variant-picker input[type="radio"]:checked'
      );
      if (checked && idInput) {
        idInput.value = checked.value;
        idInput.disabled = false;
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function neutralizeKachingForm() {
      var form = getProductForm(formId);
      if (!form) return;
      form.querySelectorAll('input[name="properties[__kaching_bundles]"]').forEach(function (input) {
        input.disabled = true;
      });
    }

    function restoreKachingForm() {
      var form = getProductForm(formId);
      if (!form) return;
      form.querySelectorAll('input[name="properties[__kaching_bundles]"]').forEach(function (input) {
        input.disabled = false;
      });
    }

    function resetBuyButtonPrice() {
      var productForm = getProductForm(formId);
      if (!productForm) return;
      lastSyncedButtonPrice = '';
      lastSyncedButtonCompare = '';
      var formattedPrice = formatMoney(config.weekenderPrice, config.moneyFormat);
      var formattedCompare = formatMoney(config.weekenderComparePrice, config.moneyFormat);
      productForm.querySelectorAll('.buy-buttons__price, .buy-buttons .igPrice').forEach(function (el) {
        if (el.closest('.product-bundle-upsell')) return;
        el.removeAttribute('data-bundle-price-locked');
        el.textContent = formattedPrice;
      });
      productForm.querySelectorAll('.buy-buttons__compare-price, .buy-buttons .igComparePrice').forEach(function (el) {
        if (el.closest('.product-bundle-upsell')) return;
        el.removeAttribute('data-bundle-price-locked');
        if (config.weekenderComparePrice > config.weekenderPrice) {
          el.textContent = formattedCompare;
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    }

    function activateBundleMode() {
      selectedOption = container.dataset.defaultSelection || 'overpacker';
      selectOption(selectedOption);
      startBuyButtonPriceGuard();
      schedulePriceSync();
      neutralizeKachingForm();
      window.BundleSelectorAb.register(formId, {
        getBundleCartItems: getBundleCartItems,
        mergeWithCheckedAddons: mergeWithCheckedAddons,
        processAtc: processAtc,
        getDiscountCode: getDiscountCode
      });
    }

    function deactivateBundleMode() {
      stopBuyButtonPriceGuard();
      if (window.BundleSelectorAb && window.BundleSelectorAb.instances) {
        delete window.BundleSelectorAb.instances[formId];
      }
      if (window.BUNDLE_SELECTOR_PENDING && window.BUNDLE_SELECTOR_PENDING.formId === formId) {
        window.BUNDLE_SELECTOR_PENDING = null;
      }
      restoreKachingForm();
      resetToVariantPicker();
      resetBuyButtonPrice();
    }

    container.addEventListener('bundle-selector:activate', activateBundleMode);
    container.addEventListener('bundle-selector:deactivate', deactivateBundleMode);

    var productForm = getProductForm(formId);
    if (productForm) {
      productForm.addEventListener('product:rerender', function () {
        if (getAbEnabled()) schedulePriceSync();
      });
      productForm.addEventListener('variant:change', function () {
        if (getAbEnabled()) schedulePriceSync();
      });
    }

    document.addEventListener('variant:change', function () {
      if (getAbEnabled()) schedulePriceSync();
      if (container.dataset.pdpType !== 'weekender') return;
      var selectedColor = getSelectedWeekender();
      if (selectedColor) applyWeekenderGalleryColor(selectedColor.color || selectedColor.title);
    });
  }

  var lastSyncedAbEnabled = null;
  var syncAbDebounce = null;

  function syncAbState(force) {
    var enabled = getAbEnabled();
    applyAbVisibility();

    if (!force && enabled === lastSyncedAbEnabled) return;
    lastSyncedAbEnabled = enabled;

    if (!enabled) {
      clearBundleDiscountIfActive();
    }

    document.querySelectorAll('.product-bundle-upsell').forEach(function (container) {
      var eventName = enabled ? 'bundle-selector:activate' : 'bundle-selector:deactivate';
      container.dispatchEvent(new CustomEvent(eventName));
    });

    document.dispatchEvent(new CustomEvent('addon-slider:refresh'));
  }

  function scheduleSyncAbState(force) {
    clearTimeout(syncAbDebounce);
    syncAbDebounce = setTimeout(function () {
      syncAbState(!!force);
    }, 50);
  }

  function init() {
    document.querySelectorAll('.product-bundle-upsell').forEach(initBundleUpsell);
    syncAbState(true);

    var abDebounce;
    var domObserver = new MutationObserver(function () {
      clearTimeout(abDebounce);
      abDebounce = setTimeout(applyAbVisibility, 80);
    });

    var observeRoot = document.querySelector('.product-info') || document.body;
    domObserver.observe(observeRoot, { childList: true, subtree: true });

    // Intelligems may flip AB attrs after paint — re-sync so backpack bundle loads when
    // data-bundle-horizontal-ab becomes true (no body writes; observe only).
    var observer = new MutationObserver(function (mutations) {
      var needsSync = false;
      var needsPacks = false;
      for (var i = 0; i < mutations.length; i++) {
        var name = mutations[i].attributeName;
        if (
          name === 'data-bundle-selector-ab' ||
          name === 'data-bundle-horizontal-ab' ||
          name === 'data-travelset-packs-ab'
        ) {
          needsSync = true;
        }
        if (name === 'data-travelset-packs-ab') needsPacks = true;
      }
      if (!needsSync) return;
      if (needsPacks) applyTravelsetPacksClass();
      scheduleSyncAbState(true);
      document.querySelectorAll('.product-bundle-upsell').forEach(function (el) {
        if (typeof el._syncTravelsetPacksMode === 'function') el._syncTravelsetPacksMode();
      });
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [
        'data-bundle-selector-ab',
        'data-bundle-horizontal-ab',
        'data-travelset-packs-ab'
      ]
    });

    // Late Intelligems assignment — short poll on backpack only (no writes)
    if (isBackpackPdpPage()) {
      loadBackpackKachingDeal();
      var polls = 0;
      var pollId = setInterval(function () {
        polls += 1;
        scheduleSyncAbState(false);
        if (polls >= 20 || getAbEnabled()) clearInterval(pollId);
      }, 250);
    }

    // Always enforce TRAVELSET / TRAVELSET20 eligibility — even when the bundle
    // selector UI is off — so leftover codes do not stick on vacuum-only carts.
    var discountGuardTimer;
    var discountGuardRunning = false;
    document.addEventListener('cart:change', function (event) {
      if (discountGuardRunning) return;
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      clearTimeout(discountGuardTimer);
      discountGuardTimer = setTimeout(function () {
        discountGuardRunning = true;
        enforceBundleDiscountEligibility(cart).finally(function () {
          discountGuardRunning = false;
        });
      }, 100);
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        enforceBundleDiscountEligibility(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
